module.exports = __webpack_public_path__ + "img/lidai.7801e056.svg";